import Controller from '@ember/controller';

export default class SignmeeTransferController extends Controller {
  title = 'SignMee Transfer';
}
